import React from "react";
import { Column } from "@ant-design/charts";
import { Skeleton } from "@pankod/refine-antd";
import { useCustom } from "@pankod/refine-core";
import ENV from "utils/env";
import { extractArray } from "../utils";

interface FiveGPhoneClicksColumnProps {
  dateRange: [string, string];
  shopCode: string | null;
}

export const FiveGPhoneClicksColumn: React.FC<FiveGPhoneClicksColumnProps> = ({
  dateRange,
  shopCode,
}) => {
  const { data: response, isFetching } = useCustom({
    url: `${ENV.API_URL}/api/analytics/stats/five-g-phone-clicks`,
    method: "get",
    config: {
      query: {
        startDate: dateRange[0],
        endDate: dateRange[1],
        limit: "20",
        ...(shopCode ? { shopCode } : {}),
      },
    },
    queryOptions: { retry: 0 },
  });

  if (isFetching) return <Skeleton active />;

  const raw = extractArray<{ productName: string; clickCount: string }>(response?.data);
  const data = raw.map((r) => ({
    product: r.productName || "Bilinmeyen",
    count: parseInt(r.clickCount, 10),
  }));

  if (data.length === 0) {
    return (
      <span style={{ color: "#8c8c8c" }}>Bu filtrelere ait veri bulunamadı.</span>
    );
  }

  const config = {
    data,
    xField: "product",
    yField: "count",
    color: "#FFC900",
    style: {
      maxWidth: 40,
    },
    label: {
      text: (d: any) => String(d.count),
      position: "inside" as const,
      style: { fill: "#1a1a1a", fontWeight: 600 },
    },
    axis: {
      x: {
        labelAutoRotate: true,
        labelFormatter: (text: string) =>
          text.length > 20 ? text.substring(0, 18) + "…" : text,
      },
    },
    tooltip: {
      title: (d: any) => d.product,
      items: [{ channel: "y", name: "Tıklanma" }],
    },
  };

  return <Column {...config} />;
};
